import { render } from "./DoctorGeneral.vue?vue&type=template&id=13a9d73e&scoped=true"
import script from "./DoctorGeneral.vue?vue&type=script&lang=js"
export * from "./DoctorGeneral.vue?vue&type=script&lang=js"

import "./DoctorGeneral.vue?vue&type=style&index=0&id=13a9d73e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a9d73e"]])

export default __exports__